module.exports = __webpack_public_path__ + "img/reflesh.4b0fe2a5.png";